import { i18n } from "services/i18nService";

export function afterGet(record) {
  const newRecord = { ...record };

  newRecord.label = { name: i18n(`global.${record.label}`), id: record.label };

  return newRecord;
}
